import { render, staticRenderFns } from "./TotalPaymentsReady.vue?vue&type=template&id=fb60e9b8&scoped=true&"
import script from "./TotalPaymentsReady.vue?vue&type=script&lang=js&"
export * from "./TotalPaymentsReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb60e9b8",
  null
  
)

export default component.exports